var map = {
	"./battles.png": "79a3",
	"./duels.png": "050d",
	"./new-logo/battles.png": "9f29",
	"./new-logo/blackjack1.png": "6a38",
	"./new-logo/cases.png": "f8c0",
	"./new-logo/crash.png": "f9ba",
	"./new-logo/duels.png": "b0bb",
	"./new-logo/mines2.png": "cd75",
	"./new-logo/roll.png": "97d6",
	"./new-logo/slots.png": "912d",
	"./new-logo/towers.png": "6c51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9f2";